import _regeneratorRuntime from "@babel/runtime/helpers/esm/regeneratorRuntime";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { updateCurrentAccount } from '../../service';
import { useStatistics } from '../../utils/statistics';
import { CommonBg } from '../common-bg';
import './index.less';
export function CreatePersonalSchool(_ref) {
  var accountInfo = _ref.accountInfo,
    _ref$onCancel = _ref.onCancel,
    onCancel = _ref$onCancel === void 0 ? function () {} : _ref$onCancel,
    _ref$onSuccess = _ref.onSuccess,
    onSuccess = _ref$onSuccess === void 0 ? function () {} : _ref$onSuccess,
    _ref$onError = _ref.onError,
    onError = _ref$onError === void 0 ? function () {} : _ref$onError;
  useStatistics('CreatePersonalSchool');
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    nickname = _useState2[0],
    setNickname = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isSaving = _useState4[0],
    setIsSaving = _useState4[1];
  var title = useMemo(function () {
    return /*#__PURE__*/React.createElement("div", null, "\u8BF7\u586B\u5199\u4E2A\u4EBA\u4FE1\u606F", /*#__PURE__*/React.createElement("div", {
      className: "login-common-bg-title-tips"
    }, "\u5B8C\u5584\u4FE1\u606F\u540E\u5373\u53EF\u4F7F\u7528\u76F4\u64AD\u548C\u73ED\u7EA7\u7B49\u529F\u80FD"));
  }, []);
  var onSaveDetail = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var _yield$updateCurrentA, _yield$updateCurrentA2, code, message;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          if (!(!nickname || isSaving)) {
            _context.next = 3;
            break;
          }
          return _context.abrupt("return");
        case 3:
          setIsSaving(true);
          _context.next = 6;
          return updateCurrentAccount(_objectSpread(_objectSpread({}, accountInfo), {}, {
            nickname: nickname
          }));
        case 6:
          _yield$updateCurrentA = _context.sent;
          _yield$updateCurrentA2 = _yield$updateCurrentA.data;
          code = _yield$updateCurrentA2.code;
          message = _yield$updateCurrentA2.message;
          setIsSaving(false);
          if (code === '0') {
            onSuccess();
          } else {
            onError(message || '保存失败，请稍候再试');
          }
          _context.next = 19;
          break;
        case 14:
          _context.prev = 14;
          _context.t0 = _context["catch"](0);
          console.warn(_context.t0);
          setIsSaving(false);
          onError('保存失败，请稍候再试');
        case 19:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 14]]);
  })), [accountInfo, isSaving, nickname, onError, onSuccess]);
  var content = useMemo(function () {
    return /*#__PURE__*/React.createElement("div", {
      className: "login-account-info"
    }, /*#__PURE__*/React.createElement("div", {
      className: "login-account-info-form-item"
    }, /*#__PURE__*/React.createElement("div", {
      className: "login-account-info-form-item-label"
    }, "\u4F60\u7684\u59D3\u540D"), /*#__PURE__*/React.createElement("div", {
      className: "login-account-info-form-item-value"
    }, /*#__PURE__*/React.createElement("input", {
      type: "text",
      className: "login-account-info-form-item-value-input",
      placeholder: "\u8BF7\u8F93\u5165\u4F60\u7684\u59D3\u540D",
      value: nickname,
      maxLength: 16,
      onChange: function onChange(e) {
        setNickname(e.target.value.trim());
      }
    }))));
  }, [nickname]);
  var footer = useMemo(function () {
    return /*#__PURE__*/React.createElement("div", {
      className: "login-account-info-bot"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "login-account-info-bot-cancel btn-plain",
      onClick: onCancel
    }, "\u53D6\u6D88"), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "login-account-info-bot-success btn-primary ".concat(!nickname || isSaving ? 'disabled' : ''),
      onClick: onSaveDetail
    }, "\u786E\u5B9A"));
  }, [isSaving, nickname, onCancel, onSaveDetail]);
  useEffect(function () {
    if (accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.nickname) {
      setNickname(accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.nickname);
    }
  }, [accountInfo.nickname]);
  return /*#__PURE__*/React.createElement("div", {
    className: "login-create-personal-school"
  }, /*#__PURE__*/React.createElement(CommonBg, {
    title: title,
    content: content,
    footer: footer
  }));
}